import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "../JobListingCard/JobListingCard2.css";
import "./BookingCard.css";
import "../../Components-Pages/Bookings2/JobList.css";
import Moment from "react-moment";
import { parseTime, teacherResponse, getClass, teacherStatus, teacherLevel, getQualificationTypeForBooking, getCustomerEltRateByTeacherLevel } from "../../Helper";
// import CancelBookingPopup from './CancelBookingPopup';
import { Link } from "react-router-dom";
// import FormDropdown from "../FormField/FormDropdown";
import ForumIcon from "@material-ui/icons/Forum";
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ReactTooltip from "react-tooltip";
import CancelBookingPopupCollege from "./CancelBookingPopupCollege";
import ChangeBookingLevelPopupCollege from "./ChangeBookingLevelPopupCollege";
import { dateToISO, getValidStartDate } from "../../Helper";
import Auth from "../../Auth/Auth";
import {permIndices} from "../../Permissions";
import CancelButton from "../Buttons/CancelButton";
import DescriptionIcon from '@mui/icons-material/Description';
import carParkingImg from '../../assets/img/car_parking.svg';
import moment from "moment";

const _ = require('lodash');

function BookingCardCollege(props) {
  const {
    job,
    inst,
    editbookings,
    minWidth,
    classData,
    confirmBookingCancel,
    confirmChangeLevel,
    selectedDate,
    dateIndex,
    user,
    customer,
    qualifications,
  } = props;
  let { campus } = props
  let [isAbleToEdit,setIsAbleToEdit] = useState(true)
  const [subTotal, setSubTotal] = useState(0);
  const [superannuation, setSuper] = useState(0);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [cancelReason, setCancelReason] = useState("")
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [updatedLevel, setUpdatedLevel] = useState("");
  const [cancelPenaltyPercent, setCancelPenaltyPercent] = useState(0)
  const [updatedLevelID, setUpdatedLevelID] = useState("")

  if(!campus || !campus._id && job?.campus) {
    campus = job.campus
  }

  //console.log('Job is: ', job);

  // const d1 = new Date().toISOString().slice(0, 10);
  const d1 = dateToISO(new Date());
  // console.log(((job.end_booking_date || job.booking_date) < d1) && (job.teacher != undefined))

  const classList = getClass();
  // let level = classList.find((cl) => cl.key === job.level);
  // level = level ? level.whole_name : job.level;
  let level = job.level

  const calculateSubTotal = () => {
    if (
      "teaching_earning_rate" in inst &&
      "non_teaching_earning_rate" in inst
    ) {
      var sum =
        inst.teaching_earning_rate * job.paid_teaching_hours +
        inst.non_teaching_earning_rate * job.paid_nonteaching_mins;
      var annuation = sum * 0.095;
      setSubTotal(sum);
      setSuper(annuation);
    }
  };

  useEffect(() => {
    setIsAbleToEdit(true);
    // Auth.authCheck(1 << permIndices.ed_book)
    //     .then((res) => {
    //       setIsAbleToEdit(res.authenticated || res.admin);
    //     })
    if (inst) {
      calculateSubTotal();
    }
  }, [inst]);

  // const selectAction = (e) => {
  //   if (e.target.value === 'cancel') {
  //     setShowCancelPopup(true);
  //   }
  // };

  const getTotalHours = (hoursPerDay) => {
    if (!job.dates.length) return hoursPerDay;
    let count = 0;
    let idx = 0;
    for (let i = 0; i < job.dates.length; i++) {
      if (job.dates[i].date === getValidStartDate(job)) {
        idx = i;
        break;
      }
    }
    for (let i = idx; i < job.dates.length; i++) {
      count++;
      if (job.dates[i].date === job.end_booking_date) break;
    }
    return count * hoursPerDay;
  };

  let avatar;
  if(job.teacher!=undefined){
    if (job.teacher.img_url) {
      avatar = (<img
          src={job.teacher.img_url}
          className="teacher-round-picture"
          alt="user's avatar"
      />)
    } else {
      avatar = (<PersonAddIcon id="person-add-icon"/>)
    }
  } else {
    avatar = (<PersonAddIcon id="person-add-icon"/>)
  }

  if (job.teacher?.first_name === 'None' && job.teacher?.last_name === 'Available') {
    avatar = <HighlightOffIcon id="person-add-icon"/>
  }

  if (job.cancelled_by_inst) {
    avatar = <DoNotDisturbIcon id="person-add-icon"/>
  }

  const startDate = new Date(job.booking_date)
  const endDate = new Date(job.end_booking_date);
  endDate.setDate(endDate.getDate() + 1);
  const daysOfWeekInRange = [];
  let i = 0;
  while (i < 7 && startDate < endDate) {
    daysOfWeekInRange.push(startDate.toLocaleString('en-us', {  weekday: 'long' }));
    startDate.setDate(startDate.getDate() + 1);
    i++;
  }
  let days = job.days_of_delivery?.replace(/^,/, "").split(",")
    .filter(value => daysOfWeekInRange.includes(value)).map(day => day.substr(0,3));
  for (let i = 0; i < days?.length; i++) {
    if (days[i] === 'Tue') {
      days[i] = 'Tues';
    } else if (days[i] === 'Wed') {
      days[i] = 'Weds';
    } else if (days[i] === 'Thu') {
      days[i] = 'Thurs'
    }
  }

  if (!job.multiple_date) {
    if (job.unavailable_teacher) {
      job.teacher = { first_name: "None", last_name: "Available" }
      avatar = <HighlightOffIcon id="person-add-icon"/>
    }
  } else {
    const unavailableSplit = job.splits?.find((split) =>
      split.unavailable_teacher && split.date_from === job.booking_date
      && split.date_to === job.end_booking_date)
    if (unavailableSplit) {
      // console.log(job)
      job.teacher = { first_name: "None", last_name: "Available" }
      avatar = <HighlightOffIcon id="person-add-icon"/>
    }
  }

  const onChangeLevel = (updatedLevel, updatedLevelID) => {
    setUpdatedLevel(updatedLevel)
    setUpdatedLevelID(updatedLevelID)
  }

  const showRateECEC = (job) => {
    const defaultRate = <>
      <p>Certificate $52.50 (including super)</p>
      <p>Diploma $62.50 (including super)</p>
      <p>Bachelor $72.50 (including super)</p>
    </>

    if (job.teacher_response === teacherResponse.accepted || job.teacher_status === teacherStatus.assigned) {
      const level = (job.teacher_status === teacherStatus.assigned && job.teacher_id)
        ? job?.teacher_assigned?.level
        : job?.teacher?.level

      if (level === teacherLevel.CERT) {
        return <p>Certificate $52.50 (including super)</p>
      } else if (level === teacherLevel.DIPLOMA) {
        return <p>Diploma $62.50 (including super)</p>
      } else if (level === teacherLevel.BACHELOR) {
        return <p>Bachelor $72.50 (including super)</p>
      } else if(level === teacherLevel.GRADUATE_DIPLOMA) {
        return <p>Graduate Diploma $72.50 (including super)</p>
      }
    }
  
    return defaultRate
  }

  const showDefaultRate = (job, inst_id) => {
    const NEW_RATE_APPLY_DATE = moment('2024-07-01', 'YYYY-MM-DD');
    const NEW_RATE_APPLY_DATE_2025 = moment('2026-07-01', 'YYYY-MM-DD');
    const bookingDate = moment(job.end_booking_date, 'YYYY-MM-DD');
    const newRateFor2025 = moment('2026-01-01', 'YYYY-MM-DD');

    if(inst_id === '6674b406b9f34b24efc2889e') {
      // CampusQ college
      return (
        <>
          Junior/Online $44
          <br />
          Senior $44
        </>
      )
    }

    if(bookingDate.isSameOrAfter(NEW_RATE_APPLY_DATE_2025)) {
      const level = job.teacher?.level
      if (job.teacher_response === "accepted" && !job.multiple_date) {
        return getCustomerEltRateByTeacherLevel(level, true)
      }

      if (job.teacher_response === "accepted" && job.multiple_date) {
        const rates = job.dates.map(date => getCustomerEltRateByTeacherLevel(date?.teacher_rate))
        return <>
          {
            [...new Set(rates)]?.map(rate =>
              <>
                {rate}
                <br/>
              </>)
          }
        </>
      }

      return (
        <>
          Junior/Online $72.88
          <br/>
          Senior $79.57
          <br/>
          Expert $86.07
          <br/>
          Master $90.53
        </>
      )
    } else if(bookingDate.isSameOrAfter(newRateFor2025)) {
      if(inst_id === '64dc1e52853fb706cdeec43d') {
        // Ames Australia college
        return (
          <>
            Hourly rate $74.27<br />
          </>
        )
      }
      const level = job.teacher?.level
      if (job.teacher_response === "accepted" && !job.multiple_date) {
        return getCustomerEltRateByTeacherLevel(level)
      }

      if (job.teacher_response === "accepted" && job.multiple_date) {
        const rates = job.dates.map(date => getCustomerEltRateByTeacherLevel(date?.teacher_rate))
        return <>
          {
            [...new Set(rates)]?.map(rate =>
              <>
                {rate}
                <br/>
              </>)
          }
        </>
      }

      return (
        <>
          Junior/Online $69.58
          <br/>
          Senior $75.97
          <br/>
          Expert $82.17
          <br/>
          Master $86.43
        </>
      );
    }
    else if (bookingDate.isSameOrAfter(NEW_RATE_APPLY_DATE)) {
      return (
        <>
          Junior/Online $67.22
          <br />
          Senior $73.40
          <br />
          Expert $79.38
          <br />
          Master $83.51
        </>
      )
    }

    return (
      <>
        Junior & Online (WFH) $62.50
        <br />
        Senior $67.50
      </>
    )
  }

  const showRate = (job, inst_id) => {
    if(inst_id == '6674b406b9f34b24efc2889e') {
      // CampusQ college
      return (
        <>
        VET $44
        </>
      )
    }
      if (!job.multiple_date) {
        return <>VET ${job?.hourly_rate_customer || 0}</>
      } else {
        const customerRates = job.dates.map(date => "$" + date.hourly_rate_customer)
        return <>VET {[...new Set(customerRates)].join(" & ")}</>
      }
  }

  const showRateUni = (job) => {
    const NEW_RATE_APPLY_DATE = moment('2024-07-01', 'YYYY-MM-DD');
    const bookingDate = moment(job.end_booking_date, 'YYYY-MM-DD');
    const newRateFor2025 = moment('2025-01-01', 'YYYY-MM-DD');
    if(bookingDate.isSameOrAfter(newRateFor2025)) {
      return (
        <>
          University English Centre $105
        </>
      )
    }
    else if (bookingDate.isSameOrAfter(NEW_RATE_APPLY_DATE)) {
      return (
        <>
          University English Centre $121.61
        </>
      )
    }
    return (
        <>
          University English Centre $115
        </>
    )
  }

  return (
    <div
      className={
        "job-card-outer" +
        (minWidth ? " job-card-small-new" : "") +
        " college-job-card-outer"
      }
    >
      <div
        className={
          "job-card-container" +
          ((job.end_booking_date || job.booking_date) < d1
            ? " past-background-color"
            : "")
        }
      >
        <div className="w-100 d-flex justify-content-between">
          <div className="d-flex align-items-center mb-2 mb-3 card-top-height">
            {job.teacher ? (
              <div className="job-card-teacher-picture-container">
                {avatar}
              </div>
            ) : null}

            <h3 className="job-card-teacher-name">
              {job.teacher &&
              Object.entries(job.teacher).length !== 0 &&
              job.teacher.constructor === Object && !job.cancelled_by_inst ? (
                <>
                  {job.teacher.first_name + " "}
                  {job.teacher.preferred_name && job.teacher.preferred_name !== job.teacher.first_name
                    ? "(" + job.teacher.preferred_name + ")" : ""}
                  {" " + job.teacher.last_name}
                  <br />
                  <Link
                    to={`/NavigateToShareProfile?id=${job.teacher._id}`}
                    target="blank"
                    className="ml-1"
                    hidden={job.teacher.first_name === 'None' && job.teacher.last_name === 'Available'}
                  >
                    <span className="job-card-tag">
                      <Icon name="share" size="large" />
                      View Profile
                    </span>
                  </Link>
                </>
              ) : (
                <div>
                  {job.cancelled_by_inst ? "Cancelled" : "Teacher Allocation in Progress"}
                </div>
              )}
            </h3>
          </div>
        </div>
        <div className="job-card-container-inner p-3 d-flex flex-column justify-content-between">
          <div className="w-100 overflow-hidden">
            <p className="style-for-date-timing">
              {job.multiple_date &&
              selectedDate ? (
                <>
                  Booking for{" "}
                  <strong>
                    <Moment format="DD MMM YYYY">{selectedDate?.date}</Moment>
                  </strong>
                  <div className={props.cancelSingleDay ? "" : "d-none"}>
                    (total period{" "}
                    <Moment format="DD MMM">{job.dates?.[0]?.date}</Moment>
                    {" "}-{" "}
                    <Moment format="DD MMM">{job.dates?.[job.dates?.length - 1]?.date}</Moment>)
                  </div>
                </>
              ) :
              job.booking_date !== job.end_booking_date ? (
                <>
                  Booking for{" "}
                  <strong>
                    <Moment format="DD MMM YYYY">{getValidStartDate(job)}</Moment>
                  </strong>
                  <br />
                  to{" "}
                  <strong>
                    <Moment format="DD MMM YYYY">{job.end_booking_date}</Moment>
                  </strong>
                </>
              ) : (
                <>
                  Booking for{" "}
                  <strong>
                    <Moment format="DD MMM YYYY">{job.booking_date}</Moment>
                  </strong>
                  <div className={props.cancelSingleDay ? "" : "d-none"}>
                    (total period{" "}
                    <Moment format="DD MMM">{job.dates?.[0]?.date}</Moment>
                    {" "}-{" "}
                    <Moment format="DD MMM">{job.dates?.[job.dates?.length - 1]?.date}</Moment>)
                  </div>
                </>
              )}
            </p>
            <p className="style-for-date-timing">
              Arrive at<strong> {parseTime(job.arrival_time)}</strong> for{" "}
              <strong>{parseTime(job.start_time)}</strong> start, ends{" "}
              <strong>{parseTime(job.end_time)} {" "}</strong>
              <p className='style-for-timezone'><i>
                    Timezone {campus?.timezone}
                    </i>
                </p>
            </p>
            <hr className="search-card-hr mb-4" />
            <table style={{"work-break": "break-all"}}>
              <tbody>
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <Icon className="map marker alternate" size="large" />
                  </td>
                  <td>
                    <p className="table-column2-margin">
                      {campus
                        ? campus.address_line1 + ', ' + (campus.address_line2 ? campus.address_line2 + ', ' : '') +
                        campus.suburb + ', ' + campus.state + ', ' + campus.postcode
                        : ""}
                    </p>
                  </td>
                </tr>
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <label className="job-list-label">
                      {user?.is_childcare_centre ? "Shift" : "Class"}
                    </label>
                  </td>
                  <td>
                    <p className="table-column2-margin">{level}</p>
                  </td>
                </tr>
                {
                  !user?.is_childcare_centre && (
                    <tr className="table-row-height">
                      <td className="icon-alignment">
                        <label className="job-list-label">Mode</label>
                      </td>
                      <td>
                        <p className="table-column2-margin">
                          {job.online ?
                            job.deliver_from_home === undefined ? "Online"
                              :
                              (job.deliver_from_home ? "Online - Deliver from home" : "Online - Deliver on-campus")
                            :
                            "On Campus"}
                        </p>
                      </td>
                    </tr>
                  )
                }
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <label className="job-list-label">tag</label>
                  </td>
                  <td>
                    <p className="table-column2-margin">{!_.isEmpty(classData) ? classData.reference_name : job?.class?.reference_name} </p>
                  </td>
                </tr>
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    {/*<label className="job-list-label">{classData.reference_name}</label>*/}
                    <label className="job-list-label">Days</label>
                  </td>
                  <td>
                    <p className="table-column2-margin">
                      { days?.join(', ') }
                    </p>
                  </td>
                </tr>
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <Icon className="clock" size="large" />
                  </td>
                  <td>
                    <p className="table-column2-margin">
                      Total {getTotalHours(job.paid_teaching_hours) || 0} paid
                      teaching hours{user?.is_childcare_centre ? "" : ","}
                      {
                        !user?.is_childcare_centre && (
                          <>
                          <br />
                            {job.paid_nonteaching_mins} paid non-teaching minutes
                            {job.paid_nonteaching_mins
                              ? job.non_teach_calculation === 'daily'
                                ? ' per day'
                                : job.non_teach_calculation === 'weekly'
                                  ? ' per week'
                                  : job.non_teach_calculation === 'monthly'
                                    ? ' per month' : ''
                              : ''}
                          </>
                        )
                      }
                    </p>
                  </td>
                </tr>
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <Icon className="dollar" size="large" />
                  </td>
                  {inst._id == "62314d2c0ad47e1c334979a3" ?
                    <td>
                      <p className="table-column2-margin">
                        $80 first hour
                        <br/>
                        $55 every subsequent hour in the same week
                      </p>
                    </td>
                    :
                    <td>
                      {/* classData.hourly_rate ? (
                          <p className="table-column2-margin">
                            ${classData.hourly_rate} (teaching rate)
                          </p>
                        ) : (
                          <p className="table-column2-margin">
                            $56.50 (teaching rate)
                          </p>
                        )*/}
                      <p className="table-column2-margin college-pricing pt-2" style={{ fontSize: "90%" }}>
                        <b>Non-uni Language Centre & RTO</b>
                        <br />
                        {
                          inst?.inst_type === 'UNI' ? 
                          (
                            inst?.institution_name === 'Torrens University Language Centre' ? 
                            <>
                              University English Centre $88.19
                            </> :
                            (showRateUni(job))
                          )
                          : (
                            getQualificationTypeForBooking(qualifications, job.class_level_id) === 'vet'
                              ?
                                <>{ showRate(job, inst?._id) }</>
                              : (user?.is_childcare_centre || (user?.role === 'admin' && customer?.is_childcare_centre))
                                ? <>{ showRateECEC(job) }</>
                                : <>{ showDefaultRate(job, inst?._id) }</>
                          )
                        }
                        {/* <b>Uni Language Centre & TAFE</b> */}
                        {/* Senior $115.00 */}
                      </p>
                    </td>
                  }
                </tr>
                {
                  user?.is_childcare_centre && (
                    <tr className="table-row-height">
                      <td className="icon-alignment">
                        <img src={carParkingImg} alt="SVG" style={{margin: "0 auto", width: "20px", height: "20px"}}/>
                      </td>
                      <td>
                        <p className="table-column2-margin">
                          {campus?.car_parking + " " || ""}
                          {
                            campus?.car_parking_location?.address
                              ? (campus?.car_parking_location?.detail ? campus?.car_parking_location?.detail + " " : "") + campus?.car_parking_location?.address 
                              : ""
                          }
                        </p>
                      </td>
                    </tr>
                  )
                }
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <Icon className="user" size="large" />
                  </td>
                  <td>
                    <p className="table-column2-margin">
                      Report to {campus?.report_to || "N/A"} on level{" "}
                      {campus?.floor_no || "N/A"}
                    </p>
                  </td>
                </tr>
                <tr className="table-row-height">
                  <td className="icon-alignment">
                    <DescriptionIcon size="large" />
                  </td>
                  <td>
                    <p className="table-column2-margin">
                    {(!_.isEmpty(classData) ? classData.class_note : job?.class?.class_note) || "No additional notes"}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className="card-buttons-position"
            hidden={job.teacher?.first_name === 'None' && job.teacher?.last_name === 'Available'}
          >
            {job.cancelled_by_inst ? (
              <p className="card-content font-weight-bold confirm-status-alignment">
                Cancelled
              </p>
            ) : (job.end_booking_date || job.booking_date) < d1 ? (
              <p className="card-content font-weight-bold confirm-status-alignment">
                {job.teacher_response === teacherResponse.cancelled ? "Expired" : "Completed"}
              </p>
            ) : job.teacher_response === teacherResponse.accepted ? (
              <p className="card-content font-weight-bold confirm-status-alignment">
                Confirmed
              </p>
            ) : job.preferred_teacher ? (
              <p className="card-content font-weight-bold confirm-status-alignment">
                <span>
                  Requested <br /> Confirmation in-progress
                </span>
              </p>
            ) : null}
          </div>
        </div>

        {
          !((job.end_booking_date || job.booking_date) < d1)
          && !job.cancelled_by_inst && isAbleToEdit 
          && (job.teacher_status !== teacherStatus.none_available && !job.unavailable_teacher)
        ? (
          props.cancelSingleDay ?
            <CancelButton
              className='mt-2 mb-1'
              onClick={() => setShowCancelPopup(true)}
            >
              Confirm cancellation
            </CancelButton>
            :
            <Icon
              name="ban"
              className="block-icon cursor-pointer"
              size="large"
              data-tip
              data-for="tooltipban"
              onClick={() => setShowCancelPopup(true)}
            />
        ) : null}

        <ReactTooltip
          place="bottom"
          backgroundColor="rgb(47, 224, 222)"
          id="tooltipban"
          effect="solid"
        >
          Cancel
        </ReactTooltip>

        <CancelBookingPopupCollege
          show={showCancelPopup}
          booking={job}
          inst={inst}
          campus={campus}
          level={level}
          onClose={() => setShowCancelPopup(false)}
          cancelSingleDay={props.cancelSingleDay}
          setCancelReason={setCancelReason}
          setCancelPenaltyPercent={setCancelPenaltyPercent}
          onConfirm={() => {
            confirmBookingCancel(job, cancelReason, cancelPenaltyPercent, dateIndex, selectedDate);
            setShowCancelPopup(false);
          }}
          selectedDate={selectedDate}
        />

        {!((job.end_booking_date || job.booking_date) < d1) &&
          !job.cancelled_by_inst && isAbleToEdit && !props.cancelSingleDay ? (
          <Icon
            name="pencil"
            className="edit-icon icon-asset material-icons-outlined cursor-pointer"
            size="large"
            data-tip
            data-for="tooltipedit"
            onClick={() => setShowEditPopup(true)}
          />
        ) : null}

        <ReactTooltip
          place="bottom"
          backgroundColor="rgb(47, 224, 222)"
          id="tooltipedit"
          effect="solid"
        >
          Edit Booking Level
        </ReactTooltip>
        <ChangeBookingLevelPopupCollege
          show={showEditPopup}
          onClose={() => setShowEditPopup(false)}
          onConfirm={() => {
            confirmChangeLevel(job, updatedLevel, updatedLevelID)
            setShowEditPopup(false)
          }}
          booking={job}
          inst={inst}
          campus={campus}
          classData={!_.isEmpty(classData) ? classData : (job?.class || {})}
          updatedLevel={updatedLevel}
          updatedLevelID={updatedLevelID}
          setUpdatedLevel={onChangeLevel}
        />
      </div>
    </div>
  );
}

export default BookingCardCollege;
